import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=c677210e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c677210e')) {
      api.createRecord('c677210e', component.options)
    } else {
      api.reload('c677210e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=c677210e&", function () {
      api.rerender('c677210e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xIHkoqCsJdyr/JS/comp/ErrorMessage.vue"
export default component.exports